// Per-user permission catalog. Drives the per-module card grid on
// UserDetail. Each MODULE describes its main toggle, a Read-Only flag, and
// either auto-generated sub-permissions (view/edit OR view/reply ×
// teammates/others) or an explicit `customSubs` list.

export const MODULES = [
  {
    key: "dashboard",
    label: "Dashboard",
    verb: null,
    customSubs: [
      { key: "dashboard_kpis",    label: "KPI Cards (counts + overdue)" },
      { key: "dashboard_charts",  label: "Charts (priority / status)" },
      { key: "dashboard_recent",  label: "Recent Activity (CDARK / Tasks / Tickets)" },
    ],
  },
  { key: "projects",            label: "CDARK",                      verb: "edit"  },
  { key: "biz_projects",        label: "Projects",                   verb: "edit"  },
  { key: "assets",              label: "Assets",                     verb: "edit"  },
  { key: "services",            label: "Services",                   verb: "edit"  },
  { key: "tasks",               label: "Tasks",                      verb: "reply" },
  {
    key: "issues",
    label: "Tickets",
    verb: "reply",
    // Auto-generated view/reply × teammates/others subs, plus the moved-in
    // `approvals_ticket` (Ticket Close Approval) toggle. Kept alongside the
    // other ticket-scoped permissions so admins configure everything about
    // tickets from a single card.
    customSubs: [
      { key: "issues_view_teammates",  label: "View Teammate's Items" },
      { key: "issues_reply_teammates", label: "Reply Teammate's Items" },
      { key: "issues_view_others",     label: "View Other User's Items" },
      { key: "issues_reply_others",    label: "Reply Other User's Items" },
      { key: "issues_status_change",   label: "Ticket Status Change Permission" },
      { key: "issues_forward_to",      label: "Forward to (re-route ticket to another team)" },
    ],
  },
  { key: "opa_requests",        label: "OPA Handle",                 verb: null    }, // view-only auto subs
  {
    key: "approvals",
    label: "Approvals",
    verb: null,
    // The approval workflow scopes — each one drives a horizontal tab on
    // the Approvals page. Ticket Close Approval moved to the Tickets card.
    customSubs: [
      { key: "approvals_opa_self", label: "OPA Approval for Self" },
      { key: "approvals_opa_team", label: "OPA Approval for Team Members" },
      { key: "approvals_project",  label: "Project Completion Approval" },
      { key: "approvals_task",     label: "Task Close Approval" },
    ],
  },
  { key: "wallets",             label: "Wallets",                    verb: null    }, // visible-wallets picker inlined
  { key: "teams_users_wallets", label: "Teams, Users & Wallets",     verb: "edit"  },
  {
    key: "settings",
    label: "Settings",
    verb: null,
    customSubs: [
      { key: "settings_branding", label: "Organization Branding (name, logo, dashboard name)" },
    ],
  },
];

const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);

// Returns the sub-permission descriptors for a module. Uses `customSubs` when
// present; otherwise auto-generates the view/(edit|reply) × teammates/others grid.
export function moduleSubKeys(mod) {
  if (mod.customSubs) return mod.customSubs;
  return [
    { key: `${mod.key}_view_teammates`, label: "View Teammate's Items" },
    ...(mod.verb ? [{ key: `${mod.key}_${mod.verb}_teammates`,
                      label: `${cap(mod.verb)} Teammate's Items` }] : []),
    { key: `${mod.key}_view_others`,    label: "View Other User's Items" },
    ...(mod.verb ? [{ key: `${mod.key}_${mod.verb}_others`,
                      label: `${cap(mod.verb)} Other User's Items` }] : []),
  ];
}

// Approval Permissions — now part of the Approvals module card.
// Kept as an empty array so older imports don't break.
export const APPROVAL_PERMS = [];

// Wallet Permissions — handled inside the Wallets module card.
export const WALLET_PERMS = [];
